/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KeyValues {
    getFixupPrototypeFunction() { return KeyValues.fixupPrototype; }

    static newInstance(model: Partial<KeyValues>): KeyValues {
        let obj = Object.assign(new KeyValues(), model);
        KeyValues.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KeyValues>): KeyValues {
        if (!model) return null;
        return KeyValues.newInstance(<KeyValues> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KeyValues) {
        if (!obj) return;

        models.KeyValues.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KeyValues): boolean {
        Object.setPrototypeOf(obj, KeyValues.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Key of the pair
     */
    key: string;

    /**
     * Values of the key
     */
    values: Array<string>;

}
